module.exports = __webpack_public_path__ + "static/media/taffiethule01.512c7660.jpg";